import { render, staticRenderFns } from "./CommonConfig.vue?vue&type=template&id=6cadc738&scoped=true"
import script from "./CommonConfig.vue?vue&type=script&lang=js"
export * from "./CommonConfig.vue?vue&type=script&lang=js"
import style0 from "./CommonConfig.vue?vue&type=style&index=0&id=6cadc738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cadc738",
  null
  
)

export default component.exports